import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Breadcrumb, Button, Form, Input, notification, Space, Spin} from "antd";
import DB_Chain from "../../../../database/dictionary/chain";
import BackButton from "../../../tech/back_button";

const EditChain = () => {
    const {token, setToken} = useContext(Context);
    const {getChain, statusChain, createChain, updateChain, dependChain} = DB_Chain(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);



    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('chain').toLowerCase()}),
            placement: 'top'
        });
    };


    const openNotificationFailedDepend = (what, by) => {
        notification.error({
            message: t('failed'),
            description:
                '\n' +
                t('e_reference', {what: what, by: by}),
            placement: 'top'
        })
    };

    useEffect(() => {
        window.scroll(0, 0)
        if (params.id != null) {
            getChain(params.id)
                .then(res => {
                    form.setFieldsValue({
                        name: res.data['name']
                    })
                    setWait(false);

                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        } else {
            setWait(false);
        }
    }, [])

    const onFinish = async (values) => {
        setWait(true);

        const formData = new FormData();
        formData.append('name', values["name"])
        if (params.id != null) {
            formData.append('id', params.id)
        }


        if (params.id == null) {
            createChain(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/trade-points/chains", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('creating'));
                    }
                })
                .catch(e => {
                    if (e.response.status === 403) {
                        window.location.reload()
                    }
                    errorConnect();
                    setWait(false);
                });

        } else {
            updateChain(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/trade-points/chains", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('updating'));
                    }
                })
                .catch(e => {
                    if (e.response.status === 403) {
                        window.location.reload()
                    }
                    errorConnect();
                    setWait(false); if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        }

    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('chain')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>



                <Form form={form}
                      labelCol={{
                          span: 8
                      }}
                      wrapperCol={{
                          span: 10
                      }}
                      layout={"vertical"}
                      onFinish={onFinish}
                      autoComplete="off"
                      id={"form"}
                >
                    <Form.Item style={{marginBottom: '10pt'}}
                               name="name"
                               label={t('name')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_input', {input: t('name').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Input showCount maxLength={100}/>
                    </Form.Item>

                </Form>
            </div>
            <Outlet/>
        </Spin>
    )
}

export default EditChain;